export default "__VITE_ASSET__bf673c78__"